import { CourseFragment } from 'src/modules/courses/documents/getCourseBySlug.generated';
import { captureException } from 'src/shared/helpers/captureException';

export const getCourseHeroImageUrl = (
    courseNode: Pick<CourseFragment, 'hero'>,
): string | undefined => {
    if (!courseNode.hero) return undefined;

    switch (courseNode.hero.__typename) {
        case 'VideoContentNode':
            return courseNode.hero.poster ?? '';
        case 'ImageNode':
            return courseNode.hero.url;
        case 'CourseGraphicHeroNode':
            return courseNode.hero.graphic.url;
        default:
            captureException(new Error('Returned unknown hero type'), {
                node: JSON.stringify(courseNode),
            });
            return undefined;
    }
};
